import React, { HTMLAttributes } from 'react';

export interface VoxelDataTableProps extends HTMLAttributes<HTMLTableElement> {}

export const VoxelDataTable = React.forwardRef<HTMLTableElement, VoxelDataTableProps>(
  ({ className, ...props }, ref) => {
    return <table className={`${className}`} {...props} ref={ref} />;
  }
);

export default VoxelDataTable;
